import { Pages } from "./pages";
import { Utility } from "./utility";

export const English = {
	Pages,
	Utility,
};
